import { render } from "./UpdateProfile.vue?vue&type=template&id=1a0175d7&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1a0175d7"

export default script